module.exports = __webpack_public_path__ + "img/TV_clean_box07.e0c1b83a.jpg";